
















































import Vue, { PropType } from "vue"
import BreadcrumbContainer from "~/components/guideline/breadcrumb/BreadcrumbContainer.vue"
import Breadcrumb, {
  BreadcrumbItem,
} from "~/components/guideline/breadcrumb/Breadcrumb.vue"
import Container from "~/components/guideline/frame/Container.vue"
import CDetailForPublic from "~/components/custom/projectDetail/CDetailForPublic.vue"
import { OUTLINED } from "~/components/guideline/icon/MaterialIcon.vue"
import WideStaticNotice from "~/components/guideline/notice/WideStaticNotice.vue"
import CProjectUserActionArea from "~/components/custom/project/projectUserAction/CProjectUserActionArea.vue"
import PFreeApplyActionArea from "~/components/custom/project/publicProject/PFreeApplyActionArea.vue"
import PPublicProjectFooter from "~/components/custom/project/publicProject/PPublicProjectFooter.vue"
import ProgressCircular from "~/components/guideline/loading/ProgressCircular.vue"
import {
  UniversalReadAcl,
  UniversalWriteAcl,
  ParticularWriteAcl,
} from "~/config/acl/accessControlList"
import { ProjectView, decorateProjectView } from "~/backendApis/viewModel"
import {
  FreeAppliableProject,
  ProjectFreeAppliableCorporationView,
} from "~/clApi/viewModel/corporationAccount"
import { UserRole } from "~/config/acl/userRoleList"

interface DataType {
  isClickedInterestedButton: boolean
  iconType: {
    OUTLINED: typeof OUTLINED
  }
  freeAppliableProject: FreeAppliableProject | null
  isActionAreaInitialized: boolean
}

export default Vue.extend({
  components: {
    BreadcrumbContainer,
    Breadcrumb,
    Container,
    CDetailForPublic,
    WideStaticNotice,
    CProjectUserActionArea,
    PFreeApplyActionArea,
    PPublicProjectFooter,
    ProgressCircular,
  },
  props: {
    project: {
      type: Object as PropType<ProjectView>,
      required: true,
    },
  },
  data(): DataType {
    return {
      isClickedInterestedButton: false,
      iconType: {
        OUTLINED,
      },
      freeAppliableProject: null,
      isActionAreaInitialized: false,
    }
  },
  computed: {
    breadcrumbItems(): BreadcrumbItem[] {
      if (
        String(this.$nuxt.$route.query.previousPage) === "corporationProfile"
      ) {
        return [
          {
            href: `/corporation/profiles/${this.project.universalCorporationId}`,
            text: "企業プロジェクト一覧",
          },
          { text: "プロジェクト詳細" },
        ]
      }

      return [
        {
          href: "/projects",
          text: "プロジェクト一覧",
        },
        { text: "プロジェクト詳細" },
      ]
    },
    isWritableAuthenticationUserResources(): boolean {
      return this.$clAuth.hasPermission(
        UniversalWriteAcl.AUTHENTICATED_USER_RESOURCES
      )
    },
    isAppliableForProject(): boolean {
      return this.$clAuth.hasPermission(ParticularWriteAcl.PROJECT_APPLY)
    },
    isReadableRequireAuthenticationResources(): boolean {
      return this.$clAuth.hasPermission(
        UniversalReadAcl.REQUIRE_AUTHENTICATION_RESOURCES
      )
    },
    isShownProjectApplyPanel(): boolean {
      return this.$clStores.projectApplyMessage.getters.isShownProjectApplyPanel
    },
    isProjectOpenForApplication(): boolean {
      return decorateProjectView(this.project).isOpenForApplication()
    },
    isFreeAppliableProject(): boolean {
      return !!this.freeAppliableProject
    },
    isUserRoleCorporation(): boolean {
      return this.$clAuth.userRole === UserRole.CORPORATION
    },
  },
  beforeMount() {
    this.$clApi.main.general.corporationAccount.read
      .getProjectFreeAppliableCorporationById({
        universalCorporationId: this.project.universalCorporationId,
      })
      .then(
        (fetchedCorporation: ProjectFreeAppliableCorporationView | null) => {
          this.freeAppliableProject =
            fetchedCorporation?.freeAppliableProjects.find(
              (project) => project.projectId === this.project.id
            ) || null
        }
      )
      .finally(() => (this.isActionAreaInitialized = true))
  },
  methods: {
    navigateToProfileCreationForm() {
      this.$nuxt.$router.push({ path: "/profiles/new/initial/job" })
    },
    openSignupPage() {
      window.location.href = `${process.env.FRONTEND_WORKER_BASE_URL}/worker/signup/`
    },
    openLoginPage() {
      this.$nuxt.$router.push({ path: "/login" })
    },
  },
})
